module.exports = __webpack_public_path__ + "img/Energy.151c3661.svg";